<template>
    <div>
        <!-- Page preloader -->
        <PagePreloader v-if="!pageIsLoaded">hashtags</PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Intro card -->
        <div class="card card-custom gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="far fa-star text-primary"></i>
                    </span>
                    <h3 class="card-label">My Hashtags</h3>
                </div>
            </div>
            <div class="card-body">
                <p>Welcome to My Hashtags, add your own Hashtag Sets using the button below.</p>
                <p>
                    Banned hashtags are
                    <mark style="background-color: #fce3e3">highlighted in red</mark> and
                    semi-banned / flagged hashtags are
                    <mark style="background-color: #fcf8e3">highlighted in yellow</mark> for your
                    convenience.
                </p>
            </div>
            <div class="card-footer row">
                <!-- NOTE - Refactored new hashtag set button -->
                <buttonCreateNewHashtagSet
                    buttonText="Create new Hashtag Set"
                    buttonColor="success"
                    buttonContainerDivClass="d-inline pr-2 pl-2 col-md-3 col-12"
                    buttonIcon="fas fa-plus-square mb-1"
                    :propMyHashtags="myhashtags"
                    buttonLocation="myhashtags"
                ></buttonCreateNewHashtagSet>
                <!-- <div class="d-inline pr-2 pl-2 col-md-3 col-12">
                    <b-button variant="success" class="mb-2 w-100" @click="openAddHashtagsetModal">
                        <i class="fas fa-plus-square mb-1"></i> Create new Hashtag Set (OLD)
                    </b-button>
                </div> -->
                <buttonManageHashtagGroups
                    :propGroups="mygroups"
                    :propSets="myhashtags"
                    v-if="myhashtags.length"
                    class="col-md-3 col-12"
                    @groupManageSuccess="handleEmitGroupManageSuccess"
                ></buttonManageHashtagGroups>
                <buttonManageHashtagGroupsOrder
                    :propGroups="mygroups"
                    v-if="mygroups.length"
                    class="col-md-3 col-12"
                    @groupManageSuccess="handleEmitGroupManageSuccess"
                ></buttonManageHashtagGroupsOrder>
            </div>
        </div>

        <!-- NOTE - CREATE hashtag set modal -->
        <!-- FIXME - This is theoretically depracted now? And replaced by it's own Component -->
        <b-modal
            size="lg"
            ref="add-hashtagset-modal"
            id="add-hashtagset-modal"
            centered
            title="Create new hashtag set"
        >
            <!-- Modal preloader -->
            <PagePreloader v-if="modalisloading"></PagePreloader>

            <!-- Error management -->
            <CustomAlerts :errors="modalerrors"></CustomAlerts>

            <form method="POST" ref="addHashtagSetForm" v-on:submit.prevent="addHashtagSet">
                <!-- Emoji picker -->
                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Icon"
                    label-for="input-default"
                >
                    <emojiPicker
                        :propCurrentEmoji="selectedEmoji"
                        @emitSavedEmoji="handleEmitEmoji"
                    ></emojiPicker>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Title"
                    label-for="input-default"
                >
                    <b-form-input
                        id="title"
                        name="title"
                        placeholder="Enter the title for your hashtag set"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Hashtags"
                    label-for="input-default"
                >
                    <b-form-textarea
                        id="hashtags"
                        name="hashtags"
                        placeholder="Enter hashtags here..."
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                </b-form-group>

                <!-- NOTE - Template managmeent to enable or not -->
                <!-- Check if share is enabled -->
                <!-- <ModalContentHashtagSetSharing
                    :form="addHashtagSetModal"
                ></ModalContentHashtagSetSharing> -->
                <!-- <template v-if="currentUser.hashtag_share_enabled">
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Share this hashtag set with others?"
                        label-for="input-default"
                    >
                        <b-form-checkbox
                            switch
                            size="lg"
                            class="pt-2"
                            name="meta_is_shared"
                            :value="1"
                            :unchecked-value="0"
                            v-model="addHashtagSetModal.meta_is_shared"
                        >
                        </b-form-checkbox>
                    </b-form-group>

                    <template v-if="addHashtagSetModal.meta_is_shared != 0">
                        <b-form-group
                            label-cols="4"
                            label-cols-lg="2"
                            label="Can other users edit this Hashtag Set?"
                            label-for="input-default"
                        >
                            <b-form-checkbox
                                switch
                                size="lg"
                                class="pt-2"
                                name="meta_is_editable_by_sharees"
                                :value="1"
                                :unchecked-value="0"
                                v-model="addHashtagSetModal.meta_is_editable_by_sharees"
                            >
                            </b-form-checkbox>
                        </b-form-group>
                    </template>
                </template> -->

                <!-- Hashtag Groups -->
                <template v-if="mygroups.length > 0">
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Hashtag Group"
                        label-for="input-default"
                    >
                        <b-form-select
                            name="group"
                            v-model="addHashtagSetSelectedGroup"
                            :options="addHashtagSetGroupOptions"
                        ></b-form-select>
                    </b-form-group>
                </template>
                <template v-if="mygroups.length < 1">
                    <input type="hidden" name="group" value="" />
                </template>

                <input type="submit" class="d-none" :disabled="modalisloading" />
            </form>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button variant="success" @click="addHashtagSet()" :disabled="modalisloading">
                    Create new hashtag set
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>

        <!-- TODO : Display message if you have no hashtag sets -->

        <!-- SECTION - Display hashtag sets -->
        <!--<div>-->

        <template v-if="pageIsLoaded">
            <!-- NOTE - Create hashtag set GROUP modal -->
            <b-modal
                size="lg"
                ref="create-hashtagsetgroup-modal"
                id="create-hashtagsetgroup-modal"
                centered
                title="Create a Hashtag Set Group"
            >
                <!-- Modal preloader -->
                <PagePreloader v-if="modalisloading"></PagePreloader>

                <!-- Error management -->
                <CustomAlerts :errors="modalerrors"></CustomAlerts>

                <InfoBox
                    text="Create a Hashtag Set Group so you can tidy up your Hashtag Sets. You can even drag and drop your existing Hashtag Sets directly into this Hashtag Set Group."
                ></InfoBox>

                <form method="POST" v-on:submit.prevent="createHashtagSetGroup">
                    <!-- Emoji picker -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Icon"
                        label-for="input-default"
                    >
                        <emojiPicker
                            :propCurrentEmoji="selectedEmoji"
                            @emitSavedEmoji="handleEmitEmoji"
                        ></emojiPicker>
                    </b-form-group>

                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Title"
                        label-for="input-default"
                    >
                        <b-form-input
                            id="title"
                            name="title"
                            v-model="creategroupmodal.title"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Hashtag Sets to add to group"
                        label-for="input-default"
                    >
                        <!-- <div class="alert row shadow-sm m-1 gutter-b" style="min-height: 50px;"> -->
                        <draggable
                            v-model="creategroupmodal.sets"
                            group="modalGroup"
                            class="alert row shadow-sm m-1 gutter-b minh50"
                        >
                            <template v-for="myhashtag in creategroupmodal.sets">
                                <span
                                    class="btn btn-sm btn-font-sm font-weight-bold m-1 btn-light-success"
                                    :key="'createmodal-' + myhashtag.id"
                                    >{{ myhashtag.emoji }} {{ myhashtag.title }}</span
                                >
                            </template>
                        </draggable>
                        <!-- </div> -->
                    </b-form-group>

                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Current Hashtag Sets"
                        label-for="input-default"
                    >
                        <!-- <div class="alert row shadow-sm m-1 gutter-b" style="min-height: 50px;"> -->
                        <draggable
                            v-model="creategroupmodal.currenthashtags"
                            group="modalGroup"
                            class="alert row shadow-sm m-1 gutter-b minh50"
                        >
                            <template v-for="myhashtag in creategroupmodal.currenthashtags">
                                <span
                                    class="btn btn-sm btn-font-sm font-weight-bold m-1 btn-light-success"
                                    :key="'createmodalcurrent-' + myhashtag.id"
                                    >{{ myhashtag.emoji }} {{ myhashtag.title }}</span
                                >
                            </template>
                        </draggable>
                        <!-- </div> -->
                    </b-form-group>

                    <input type="submit" class="d-none" :disabled="modalisloading" />
                </form>

                <template v-slot:modal-footer="{ ok, cancel, hide }">
                    <b-button
                        type="Submit"
                        variant="success"
                        @click="createHashtagSetGroup"
                        :disabled="modalisloading"
                    >
                        Create Group
                    </b-button>
                    <!-- Button with custom close trigger value -->
                    <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
                </template>
            </b-modal>

            <!-- NOTE - UPDATE hashtag set modal -->
            <b-modal
                size="lg"
                ref="update-hashtagset-modal"
                id="update-hashtagset-modal"
                centered
                title="Update your existing hashtag set"
            >
                <!-- Modal preloader -->
                <PagePreloader v-if="modalisloading"></PagePreloader>

                <!-- Error management -->
                <CustomAlerts :errors="modalerrors"></CustomAlerts>

                <form
                    method="POST"
                    ref="updateHashtagSetForm"
                    v-on:submit.prevent="updateHashtagSet"
                >
                    <!-- Emoji picker -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Icon"
                        label-for="input-default"
                    >
                        <emojiPicker
                            :propCurrentEmoji="updatemodal.emoji"
                            @emitSavedEmoji="handleEmitEmoji"
                        ></emojiPicker>
                    </b-form-group>

                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Title"
                        label-for="input-default"
                    >
                        <b-form-input
                            id="title"
                            name="title"
                            v-bind:value="updatemodal.title"
                        ></b-form-input>
                    </b-form-group>

                    <ModalContentHashtagSetSharing
                        :form="updatemodal"
                    ></ModalContentHashtagSetSharing>

                    <!-- NOTE - Templating to authorize or not -->
                    <!-- <template v-if="currentUser.hashtag_share_enabled">
                        <template v-if="currentUser.id == updatemodal.userid">
                            <b-form-group
                                label-cols="4"
                                label-cols-lg="2"
                                label="Shared this hashtag set with others?"
                                label-for="input-default"
                            >
                                <b-form-checkbox
                                    switch
                                    size="lg"
                                    class="pt-2"
                                    name="threeDots"
                                    v-model="updatemodal.meta_is_shared"
                                    :value="1"
                                    :unchecked-value="0"
                                >
                                </b-form-checkbox>
                            </b-form-group>

                            <template v-if="updatemodal.meta_is_shared != 0">
                                <b-form-group
                                    label-cols="4"
                                    label-cols-lg="2"
                                    label="Can other users edit this Hashtag Set?"
                                    label-for="input-default"
                                >
                                    <b-form-checkbox
                                        switch
                                        size="lg"
                                        class="pt-2"
                                        name="threeDots"
                                        v-model="updatemodal.meta_is_editable_by_sharees"
                                        :value="1"
                                        :unchecked-value="0"
                                    >
                                    </b-form-checkbox>
                                </b-form-group>
                            </template>
                        </template>
                    </template> -->

                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Hashtags"
                        label-for="input-default"
                    >
                        <b-form-textarea
                            id="hashtags"
                            name="hashtags"
                            placeholder="Enter hashtags here..."
                            rows="3"
                            max-rows="6"
                            v-bind:value="updatemodal.hashtags"
                        ></b-form-textarea>
                    </b-form-group>

                    <input type="hidden" name="id" v-bind:value="updatemodal.id" />
                    <input type="submit" class="d-none" :disabled="modalisloading" />
                </form>

                <template v-slot:modal-footer="{ ok, cancel, hide }">
                    <b-button
                        type="Submit"
                        variant="success"
                        @click="updateHashtagSet"
                        :disabled="modalisloading"
                    >
                        Update hashtag set
                    </b-button>
                    <!-- Button with custom close trigger value -->
                    <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
                </template>
            </b-modal>

            <!-- NOTE - Delete hashtag set modal -->
            <b-modal
                ref="delete-hashtagset-modal"
                id="delete-hashtagset-modal"
                centered
                title="Are you sure you want to delete this hashtag set?"
            >
                <!-- Modal preloader -->
                <PagePreloader v-if="modalisloading"></PagePreloader>

                <!-- Error management -->
                <CustomAlerts :errors="modalerrors"></CustomAlerts>

                <p class="lead">{{ deletemodal.title }}</p>
                <sub>{{ deletemodal.hashtags }}</sub>

                <template v-slot:modal-footer="{ ok, cancel, hide }">
                    <b-button
                        variant="danger"
                        @click="deleteHashtagSet(deletemodal)"
                        :disabled="modalisloading"
                    >
                        Delete Hashtag Set
                    </b-button>
                    <!-- Button with custom close trigger value -->
                    <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
                </template>
            </b-modal>

            <!-- NOTE - SHUFFLE hashtag set modal -->
            <b-modal
                size="lg"
                ref="shuffle-hashtagset-modal"
                id="shuffle-hashtagset-modal"
                centered
                title="Shuffle your hashtag set"
            >
                <!-- Error management -->
                <CustomAlerts :errors="modalerrors"></CustomAlerts>

                <form ref="shuffleHashtagsForm">
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Hashtags to shuffle"
                        label-for="input-default"
                    >
                        <b-form-textarea
                            id="hashtags"
                            name="hashtags"
                            placeholder="Enter hashtags here..."
                            rows="3"
                            max-rows="6"
                            :value="shufflemodal.hashtags"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        :label="'Number of hashtags (' + shuffleCount + ')'"
                        label-for="input-default"
                    >
                        <b-form-input
                            id="hashtagrange"
                            name="hashtagrange"
                            v-model="shuffleCount"
                            type="range"
                            min="0"
                            max="35"
                        ></b-form-input>
                    </b-form-group>

                    <!-- Remove duplicates -->
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Remove duplicates?"
                        class="mb-1"
                    >
                        <b-form-checkbox
                            switch
                            size="lg"
                            name="relevant"
                            class="pt-2"
                            v-model="removeDuplicates"
                        ></b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Include black dots when copying?"
                        class="mb-1"
                    >
                        <b-form-checkbox
                            switch
                            size="lg"
                            class="pt-2"
                            name="threeDots"
                            v-model="shufflemodal.includeThreeDots"
                        >
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Results"
                        label-for="input-default"
                    >
                        <b-form-textarea
                            id="shuffledhashtags"
                            name="shuffledhashtags"
                            placeholder="Enter hashtags here..."
                            rows="3"
                            max-rows="6"
                            v-bind:value="shuffledhashtags"
                        ></b-form-textarea>
                    </b-form-group>
                </form>

                <template v-slot:modal-footer="{ ok, cancel, hide }">
                    <button class="btn btn-light-success copy-hashtags-button">
                        <i class="far fa-clipboard"></i>
                        <span class="innerText">Copy to clipboard</span>
                    </button>
                    <p class="copyHashtags" style="position: absolute; left: -99999999em">
                        <template v-if="shufflemodal.includeThreeDots">
                            • <br />• <br />• <br />• <br />• <br />
                        </template>
                        {{ shuffledhashtags }}
                    </p>
                    <b-button
                        variant="success"
                        @click="
                            shuffleHashtagSet(
                                shufflemodal.hashtags,
                                shuffleCount,
                                removeDuplicates,
                                'modal'
                            )
                        "
                    >
                        Shuffle hashtag set
                    </b-button>
                    <!-- Button with custom close trigger value -->
                    <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
                </template>
            </b-modal>

            <!-- NOTE - Hashtag Set Groups Navigation -->
            <div class="card card-custom gutter-b">
                <div class="card-header">
                    <div class="card-title">
                        <h3 class="font-weight-bold mb-5 mr-10 pt-5">
                            Hashtag Groups
                            <div
                                class="symbol symbol-30 symbol-light-primary ml-2"
                                id="add-group-tooltip"
                            >
                                <a @click="openAddHashtagSetGroupModal">
                                    <span class="symbol-label font-weight-bold">
                                        <i class="fa flaticon2-plus font-size-sm"></i>
                                    </span>
                                </a>
                            </div>
                            <b-tooltip target="add-group-tooltip" triggers="hover">
                                Create a new <b>Group</b> to tidy your Hashtag Sets in!
                            </b-tooltip>
                        </h3>
                        <ul class="nav nav-success nav-pills" id="myTab2" role="tablist">
                            <!-- NOTE - ALL nav item -->
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    @click="setCurrentGroup('all')"
                                    :class="'all' == currentGroup ? 'active' : ''"
                                >
                                    <span class="nav-icon">
                                        <i class="fas fa-home"></i>
                                    </span>
                                    <span class="nav-text">All</span>
                                </a>
                            </li>
                            <!-- NOTE - Loop through existing groups -->
                            <template v-if="mygroups">
                                <li
                                    class="nav-item"
                                    v-for="group in mygroups"
                                    :key="'nav' + group.id"
                                >
                                    <a
                                        class="nav-link"
                                        @click="setCurrentGroup(group.id)"
                                        :class="group.id == currentGroup ? 'active' : ''"
                                    >
                                        <template v-if="group.emoji">
                                            <span class="nav-icon">
                                                {{ group.emoji }}
                                            </span>
                                        </template>

                                        <span class="nav-text">{{ group.title }}</span>
                                    </a>
                                </li>
                            </template>
                            <!-- NOTE - Uncategorized hashtags -->
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    @click="setCurrentGroup('uncategorized')"
                                    :class="'uncategorized' == currentGroup ? 'active' : ''"
                                >
                                    <span class="nav-icon">
                                        <i class="fas fa-stream"></i>
                                    </span>
                                    <span class="nav-text">Uncategorized</span>
                                </a>
                            </li>
                            <!-- NOTE - Only display if user either is allowed to share hashtags, or can receive shared hashtags -->
                            <template
                                v-if="
                                    currentUser.hashtag_share_parent ||
                                    currentUser.hashtag_share_enabled
                                "
                            >
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        @click="setCurrentGroup('shared')"
                                        :class="'shared' == currentGroup ? 'active' : ''"
                                    >
                                        <span class="nav-icon">
                                            <i class="fas fa-share-square"></i>
                                        </span>
                                        <span class="nav-text">Shared</span>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- NOTE - Display a message if the current group is the shared group -->
            <template v-if="currentGroup == 'shared'">
                <div class="card card-custom gutter-b">
                    <div class="card-header" style="border-bottom-width: 0px">
                        <div class="card-title">
                            <h3 class="card-label">
                                <template v-if="currentUser.hashtag_share_enabled">
                                    This section is used for hashtags that you have shared with
                                    others.
                                </template>
                                <template v-else>
                                    This section contains hashtag sets that have been shared with
                                    you by others.
                                </template>
                            </h3>
                        </div>
                    </div>
                </div>
            </template>

            <!-- NOTE - Display Hashtag Sets -->
            <transition-group class="row" mode="out-in">
                <div
                    class="col-xl-6 gutter-b"
                    v-for="myhashtag in orderedHashtags()"
                    :key="'sets-' + myhashtag.id"
                    v-if="isCurrentGroup(myhashtag)"
                >
                    <div class="card card-custom">
                        <div class="card-header ribbon ribbon-top">
                            <!-- Note - Check if this hashtag set is shared  -->
                            <template v-if="myhashtag.meta_is_shared">
                                <div class="ribbon-target bg-danger" style="top: -2px; right: 20px">
                                    Shared
                                </div>
                            </template>
                            <div class="card-title align-items-start flex-column py-3">
                                <!-- <span class="card-icon">
                                <i class="flaticon2-chat-1 text-primary"></i>
                            </span> -->
                                <h3 class="card-label mt-2">
                                    <template v-if="myhashtag.emoji">
                                        <span class="mr-2 font-size-h1">{{ myhashtag.emoji }}</span>
                                    </template>
                                    {{ myhashtag.title }}
                                </h3>
                                <span class="text-muted font-weight-bold font-size-sm mt-1"
                                    >{{ myhashtag.count }} hashtags</span
                                >
                            </div>
                            <template v-if="canEditHashtagSet(myhashtag)">
                                <div class="card-toolbar">
                                    <b-dropdown
                                        size="sm"
                                        no-caret
                                        variant="hover-light-primary"
                                        class="m-2 btn btn-hover-light-primary btn-icon btn-sm"
                                    >
                                        <template v-slot:button-content>
                                            <i class="ki ki-bold-more-hor"></i>
                                        </template>
                                        <b-dropdown-item @click="openUpdateModal(myhashtag)"
                                            ><i class="fas fa-edit mr-2"></i> Edit</b-dropdown-item
                                        >
                                        <template v-if="currentUser.id == myhashtag.userid">
                                            <b-dropdown-item @click="openDeleteModal(myhashtag)"
                                                ><i class="fas fa-trash-alt mr-2"></i>
                                                Delete</b-dropdown-item
                                            >
                                        </template>
                                    </b-dropdown>
                                </div>
                            </template>
                            <template v-else>
                                <div class="card-toolbar">
                                    <b-dropdown
                                        size="sm"
                                        no-caret
                                        variant="hover-light-primary"
                                        class="m-2 btn btn-hover-light-primary btn-icon btn-sm"
                                    >
                                        <template v-slot:button-content>
                                            <i class="ki ki-bold-more-hor"></i>
                                        </template>
                                        <b-dropdown-item
                                            ><i class="fas fa-edit mr-2"></i> This Hashtag Set is
                                            read-only</b-dropdown-item
                                        >
                                    </b-dropdown>
                                </div>
                            </template>
                        </div>
                        <div class="card-body">
                            <template v-if="myhashtag.includeThreeDots">
                                • <br />• <br />• <br />• <br />• <br />
                            </template>
                            <span v-html="myhashtag.hashtags_markdown"> </span>
                            <!-- {{ myhashtag.hashtags }} -->
                        </div>
                        <div class="card-footer d-flex justify-content-between">
                            <button
                                class="btn btn-light-success col-xl-4 copy-hashtags-button mr-2"
                            >
                                <i class="far fa-clipboard"></i>
                                <span class="innerText">Copy to clipboard</span>
                            </button>

                            <p class="copyHashtags" style="position: absolute; left: -99999999em">
                                <template v-if="myhashtag.includeThreeDots">
                                    • <br />• <br />• <br />• <br />• <br />
                                </template>
                                {{ myhashtag.hashtags }}
                            </p>
                            <a
                                @click="analyseHashtags(myhashtag)"
                                class="btn btn-light-primary col-xl-4 mr-2"
                                >Analyse</a
                            >
                            <b-button
                                variant="outline-secondary"
                                class="col-xl-4"
                                @click="openShuffleModal(myhashtag)"
                            >
                                Shuffle Hashtags
                            </b-button>
                        </div>
                        <b-form-checkbox
                            switch
                            class="pb-5 ml-10"
                            v-model="myhashtag.includeThreeDots"
                        >
                            Include black dots when copying
                        </b-form-checkbox>
                    </div>
                </div>
            </transition-group>
        </template>

        <!--</div>-->
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
.fade-leave-active {
    transition: all 0.3s;
}

.fade-leave-to {
    opacity: 0;
}

body.modal-open {
    overflow: visible;
    position: absolute;
}
.modal-body {
    overflow-y: auto;
}
.minh50 {
    min-height: 50px;
}
.list-enter-active,
.list-leave-active,
.list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}
</style>
<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import { mapGetters } from "vuex";
// Lodash
import _ from "lodash";
// Draggable
import draggable from "vuedraggable";
// Clipboard
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import emojiPicker from "@/view/content/Custom/emojiPicker.vue";
import buttonManageHashtagGroups from "@/view/content/Custom/buttonManageHashtagGroups.vue";
import buttonManageHashtagGroupsOrder from "@/view/content/Custom/buttonManageHashtagGroupsOrder.vue";
import buttonCreateNewHashtagSet from "@/view/content/Custom/buttonCreateNewHashtagSet.vue";
import InfoBox from "@/view/content/Custom/InfoBox.vue";
import ModalContentHashtagSetSharing from "@/view/content/Custom/ModalContentHashtagSetSharing.vue";
// Mixins
import hashtagShuffle from "@/mixins/hashtagShuffle";
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "MyHashtags",
    mixins: [hashtagShuffle, axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
        emojiPicker,
        draggable,
        buttonManageHashtagGroups,
        buttonManageHashtagGroupsOrder,
        buttonCreateNewHashtagSet,
        InfoBox,
        ModalContentHashtagSetSharing,
    },
    data() {
        return {
            // Preloader
            pageIsLoaded: false,

            // Data
            myhashtags: [],
            mygroups: [],
            allmyhashtags: [],

            // Group management
            currentGroup: "all",

            // Modals
            modalisloading: false,
            addHashtagSetModal: {
                meta_is_shared: 0,
                meta_is_editable_by_sharees: 0,
            },
            deletemodal: [],
            updatemodal: [],
            shufflemodal: [],
            addHashtagSetSelectedGroup: null,
            addHashtagSetGroupOptions: [],
            creategroupmodal: {
                title: "",
                sets: [],
                currenthashtags: [],
            },
            managegroupmodal: {
                sets: [],
                groups: [],
            },
            managegroups: [],

            // Emoji management
            selectedEmoji: "",

            // Error management
            errors: [],
            modalerrors: [],

            // Shuffling
            shuffleCount: 15,
            shuffledhashtags: [],
            removeDuplicates: false,
        };
    },

    methods: {
        // Get all hashtag sets from the API
        getMyHashtags() {
            // Set preloader
            this.pageIsLoaded = false;

            // Perform GET
            axios
                .get("myhashtagsv2/all")
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Set data
                    this.myhashtags = data.data.sets;
                    this.mygroups = data.data.groups;

                    // Generate group options for dropdown
                    this.addHashtagSetGroupOptions = [];
                    this.addHashtagSetGroupOptions.push({ value: null, text: "Uncategorized" });
                    this.mygroups.forEach((currentItem) => {
                        var curEmoji = "";
                        if (currentItem.emoji && currentItem.emoji != null) {
                            curEmoji = currentItem.emoji;
                        }
                        this.addHashtagSetGroupOptions.push({
                            value: currentItem.id,
                            text: curEmoji + " " + currentItem.title,
                        });
                    });

                    // Get ALL my hashtags hack
                    // this.allmyhashtags = JSON.parse(JSON.stringify(this.myhashtags));
                    // this.allmyhashtags = this.allmyhashtags.sort(function (a, b) {
                    //     return a.id - b.id;
                    // });
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.pageIsLoaded = true;
                });
        },

        orderMyHashtags(hashtags) {
            // Check if current page is different from ALL / uncategorized
            // if (this.currentGroup != "all") {
            //     // Order hashtags by ID
            //     return hashtags.sort(function (a, b) {
            //         return a.id - b.id;
            //     });
            // }

            // Default to return hashtags as they are
            return hashtags;
        },

        // Initialize all copy-hashtags buttons
        initCopyHashtags() {
            var clipboard = new ClipboardJS(".copy-hashtags-button", {
                target: function (trigger) {
                    return trigger.nextElementSibling;
                },
            });

            clipboard.on("success", function (e) {
                e.trigger.children[1].innerText = "Copied!";
                setTimeout(function () {
                    e.trigger.children[1].innerText = "Copy to clipboard";
                }, 2000);
            });
        },

        // Open delete hashtagset modal
        openDeleteModal(myhashtag) {
            // Reset errors
            this.modalerrors = [];
            this.modalisloading = false;

            // Set data
            this.deletemodal = myhashtag;

            // Open modal
            this.$refs["delete-hashtagset-modal"].show();
        },

        // Deletes a hashtag set
        deleteHashtagSet(set) {
            // Reset all errors
            this.modalerrors = [];

            // Set as loading
            this.modalisloading = true;

            // Get response
            axios
                .get("myhashtagsv2/delete/" + set.id)
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Add data
                        this.myhashtags.splice(this.myhashtags.indexOf(set), 1);
                        this.$refs["delete-hashtagset-modal"].hide();
                    }

                    // Manage errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((currentItem) => {
                            this.modalerrors.push({
                                type: currentItem.type,
                                message: currentItem.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.modalisloading = false;
                });
        },

        /**
         * NOTE - All this has been deprecated in favor of a refactored button that just works everywhere
         */
        /*
        openAddHashtagsetModal() {
            // Reset errors
            this.modalerrors = [];

            // Set loader
            this.modalisloading = false;

            // Reset options
            this.addHashtagSetSelectedGroup = null;

            // Reset the meta parameters
            this.addHashtagSetModal = {
                meta_is_shared: 0,
                meta_is_editable_by_sharees: 0,
            };

            // Reset emoji
            this.resetSelectedEmoji();

            // Open modal
            this.$refs["add-hashtagset-modal"].show();
        },

        // Add hashtag set
        addHashtagSet() {
            // Reset errors
            this.modalerrors = [];

            // Set loader
            this.modalisloading = true;

            // Define variables
            var title = this.$refs.addHashtagSetForm.title.value;
            var hashtags = this.$refs.addHashtagSetForm.hashtags.value;
            var emoji = this.selectedEmoji;
            var group = this.$refs.addHashtagSetForm.group.value;

            var meta_is_shared = this.addHashtagSetModal.meta_is_shared;
            var meta_is_editable_by_sharees = this.addHashtagSetModal.meta_is_editable_by_sharees;

            // Perform post
            axios
                .post("myhashtagsv2/create", {
                    title: title,
                    hashtags: hashtags,
                    emoji: emoji,
                    group: group,
                    meta_is_shared: meta_is_shared,
                    meta_is_editable_by_sharees: meta_is_editable_by_sharees,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Handle
                    if (data.status == "OK") {
                        // Add new hashtag to array
                        if (group) {
                            this.myhashtags.push(data.data); // Adds to the end of the array
                        } else {
                            this.myhashtags.unshift(data.data); // Adds to the beginning of the array
                        }

                        // Remove all errors
                        this.modalerrors = [];

                        // Close the modal
                        this.$refs["add-hashtagset-modal"].hide();

                        // Reset the content of the form
                        this.$refs.addHashtagSetForm.title.value = "";
                        this.$refs.addHashtagSetForm.hashtags.value = "";

                        if (data.messages.length > 0) {
                            data.messages.forEach((item) => {
                                this.errors.push({
                                    type: item.type,
                                    message: item.message,
                                });
                            });
                        }
                    }

                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.modalerrors.push({
                                type: item.type,
                                message: item.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.modalisloading = false;
                });
        }, */

        // Open UPDATE hashtag set modal
        openUpdateModal(myhashtag) {
            // Reset errors
            this.modalerrors = [];
            this.modalisloading = false;

            // Reset emoji
            this.resetSelectedEmoji();

            // Set data
            this.updatemodal = myhashtag;
            this.selectedEmoji = this.updatemodal.emoji;

            // Open modal
            this.$refs["update-hashtagset-modal"].show();
        },

        // UPDATE hashtag set
        updateHashtagSet() {
            // Remove all errors
            this.modalerrors = [];

            // Set loader
            this.modalisloading = true;

            // Define variables
            var title = this.$refs.updateHashtagSetForm.title.value;
            var hashtags = this.$refs.updateHashtagSetForm.hashtags.value;
            var id = this.$refs.updateHashtagSetForm.id.value;
            var emoji = this.selectedEmoji;
            var meta_is_shared = this.updatemodal.meta_is_shared;
            var meta_is_editable_by_sharees = this.updatemodal.meta_is_editable_by_sharees;
            var sharees = this.updatemodal.sharees_selected;

            // Perform query
            // Perform POST
            axios
                .post("myhashtagsv2/edit", {
                    title: title,
                    hashtags: hashtags,
                    id: id,
                    emoji: emoji,
                    meta_is_shared: meta_is_shared,
                    meta_is_editable_by_sharees: meta_is_editable_by_sharees,
                    sharees: sharees,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Handle status
                    if (data.status == "OK") {
                        // Update the hashtag
                        var foundIndex = this.myhashtags.findIndex((x) => x.id == data.data.id);
                        this.myhashtags[foundIndex] = data.data;

                        // Remove errors
                        this.modalerrors = [];

                        // Close modal
                        this.$refs["update-hashtagset-modal"].hide();
                    }

                    // Do error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.modalerrors.push({
                                type: item.type,
                                message: item.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.modalisloading = false;
                });
        },

        // Open shuffle modal
        openShuffleModal(myhashtag) {
            // Reset errors
            this.modalerrors = [];

            // Reset default shuffle count
            this.shuffleCount = 15;

            // Assign hashtags
            this.shufflemodal = myhashtag;

            // Prepare shuffled hashtags
            var hashtagstoshuffle = this.prepareShuffleString(
                myhashtag.hashtags,
                this.removeDuplicates
            );

            // Check if we're not shuffling a hashtag set that's smaller than the default value of 15
            if (hashtagstoshuffle.length < this.shuffleCount) {
                this.shuffleCount = hashtagstoshuffle.length;
            }

            // Do initial shuffle
            this.shuffledhashtags = this.doHashtagShuffle(
                hashtagstoshuffle,
                this.shuffleCount,
                "modal"
            );

            /// Open modal
            this.$refs["shuffle-hashtagset-modal"].show();
        },

        // Open the create new group modal
        openAddHashtagSetGroupModal() {
            // Reset errors
            this.modalerrors = [];
            this.modalisloading = false;

            // Reset emoji
            this.resetSelectedEmoji();

            // Reset the selected sets selection
            this.creategroupmodal.sets = [];
            this.creategroupmodal.currenthashtags = [];

            // Create an array of the existing hashtags that we can move around
            this.myhashtags.forEach((currentItem) => {
                this.creategroupmodal.currenthashtags.push({
                    id: currentItem.id,
                    title: currentItem.title,
                    emoji: currentItem.emoji,
                });
            });

            // Open modal
            this.$refs["create-hashtagsetgroup-modal"].show();
        },

        createHashtagSetGroup() {
            // Reset errors
            this.modalerrors = [];

            // Set loader
            this.modalisloading = true;

            // Define variables
            var title = this.creategroupmodal.title;
            var emoji = this.selectedEmoji;
            var sets = this.creategroupmodal.sets;

            // Perform post
            axios
                .post("myhashtagsv2/groups/create", {
                    title: title,
                    sets: sets,
                    emoji: emoji,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Handle
                    if (data.status == "OK") {
                        // Remove all errors
                        this.modalerrors = [];

                        // Close the modal
                        this.$refs["create-hashtagsetgroup-modal"].hide();

                        // Reload all hashtags
                        this.getMyHashtags();

                        // Reset the content of the form
                        this.creategroupmodal.title = "";

                        if (data.messages.length > 0) {
                            data.messages.forEach((item) => {
                                this.errors.push({
                                    type: item.type,
                                    message: item.message,
                                });
                            });
                        }
                    }

                    // Handle error messages
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.modalerrors.push({
                                type: item.type,
                                message: item.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.modalisloading = false;
                });
        },

        // openManageHashtagSetGroups() {
        //     // Clean up things?
        //     this.modalerrors = [];
        //     this.modalisloading = false;

        //     // Empty array
        //     this.managegroups = [];

        //     // Loop through mygroups
        //     this.mygroups.forEach((currentItem) => {
        //         this.managegroups.push(currentItem);
        //     });

        //     // Add uncategorized subarray
        //     this.managegroups.push({
        //         id: "uncategorized",
        //         title: "Uncategorized",
        //         emoji: "",
        //     });

        //     // Add Shared subarray
        //     this.managegroups.push({
        //         id: "shared",
        //         title: "Shared",
        //         emoji: "",
        //     });

        //     // Loop through all your existing groups
        //     this.managegroups.forEach((part, index, theArray) => {
        //         // Add an empty sets array to each
        //         theArray[index].sets = [];

        //         // Loop through hashtags to add them
        //         this.myhashtags.forEach((currentItem) => {
        //             // Add as we need
        //             if (part.id == currentItem.set_parent) {
        //                 theArray[index].sets.push({
        //                     id: currentItem.id,
        //                     title: currentItem.title,
        //                     emoji: currentItem.emoji,
        //                 });
        //             }
        //         });
        //     });

        //     this.$refs["manage-hashtagsetgroup-modal"].show();
        // },

        analyseHashtags(hashtagset) {
            this.$router.push({
                name: "bulk",
                params: { propHashtags: hashtagset.hashtags },
            });
        },

        handleEmitEmoji(emoji) {
            this.selectedEmoji = emoji;
        },

        handleEmitGroupManageSuccess() {
            this.getMyHashtags();
        },

        resetSelectedEmoji() {
            this.selectedEmoji = null;
        },

        isCurrentGroup(myhashtags) {
            if (this.currentGroup == "all") {
                return true;
            } else if (this.currentGroup == "shared") {
                if (myhashtags.meta_is_shared) {
                    return true;
                }
            } else {
                if (myhashtags.set_parent == this.currentGroup) {
                    return true;
                }
            }

            return false;
        },

        orderedHashtags() {
            if (this.currentGroup != "all") {
                return this.myhashtags;
            }
            return this.methodOrderedAllHashtags(); // Doesn't use a computed method, but reactiveness works when editing / add hashtags
            // return this.computedOrderedAllHashtags; // Not as reactive (editing doesn't work)
        },

        methodOrderedAllHashtags() {
            return _.orderBy(this.myhashtags, "id");
        },

        setCurrentGroup(group) {
            this.currentGroup = group;
        },

        // Checks to see if there are hashtags that were shared by others and that are availble here
        hasSharedHashtagsByOthers() {
            // Check to see if we have hashtags
            if (this.myhashtags.length) {
                return this.myhashtags.filter((obj) => obj.userid != this.currentUser.id).length;
            }
            return 0;
        },

        // Checks to see if we've shared hashtags
        hasSharedHashtags() {
            if (this.myhashtags.length) {
                return this.myhashtags.filter(
                    (obj) => obj.userid == this.currentUser.id && obj.meta_is_shared == 1
                ).length;
            }
            return 0;
        },

        // The sum of all shared hashtags
        countAllSharedHashtags() {
            return this.hasSharedHashtags() + this.hasSharedHashtagsByOthers();
        },

        // Checks to see if we can edit / delete a hashtag set
        canEditHashtagSet(hset) {
            if (hset.meta_is_editable_by_sharees == 0 && hset.userid != this.currentUser.id) {
                return false;
            }
            return true;
        },

        // log: function (evt) {
        //     window.console.log(evt);
        // },
    },
    computed: {
        ...mapGetters({ currentUser: "auth/currentUser" }),
        // computedOrderedAllHashtags() {
        //     return _.orderBy(this.myhashtags, "id");
        // },
    },

    mounted() {
        this.initCopyHashtags();
        this.getMyHashtags();
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "My Hashtags", route: "myhashtags" }]);
    },
};
</script>
